export default "/assets/images/real-time-air-alert-thumbnail.05f210b5fd58a4f9.jpg";